export enum ReportTransactionType {
  AllTransactions = "AllTransactions",
  UnSubmitted = "UnSubmitted",
  Submitted = "Submitted",
}
